export default "__VITE_ASSET__9qpV_mIk__"